module.exports = __webpack_public_path__ + "static/kvm_11.346029a1.jpg";